import React from "react";
import styled from "styled-components";
import { useScrollDirection } from "react-use-scroll-direction";
import { Link } from "react-router-dom";

const Ul = styled.ul`
  flex-flow: column nowrap;
  background-color: #111517;
  position: fixed;
  transform: ${({ open }) => (open ? "translateX(0)" : "translateX(100%)")};
  top: 0;
  right: 0;
  height: 100vh;
  width: 50%;
  padding-top: 3.5rem;
  transition: transform 0.5s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  li {
    display: list-item;
    text-align: center;
    margin: 8px 0;
    cursor: pointer;
    list-style: none;
    font-size: 55px;
    line-height: 1;
    font-weight: bold;
    font-family: "Oswald", sans-serif;
    color: white;
    white-space: nowrap;
    text-transform: uppercase;

    /* Animation on hover on LI */
    background: linear-gradient(to right, midnightblue, #4296e7 50%, #fff 50%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-size: 200% 100%;
    background-position: 100%;
    transition: background-position 275ms ease;
    &:hover {
      background-position: 0 100%;
    }
  }

  @media (max-width: 980px) {
    width: 100%;
    li {
      text-decoration: uppercase;
      font-size: 20px;
      margin: 20px 0;
      font-weight: 500;
    }
  }
`;

const IMG = styled.div`
  position: absolute;
  top: 4px;
  left: 14px;
`;

const NavBar = ({
  open,
  intro,
  services,
  processus,
  value,
  contact,
  processusPhone,
}) => {
 
  const handleScroll = (ref) => {
    window.scrollTo({
      top: ref.current.offsetTop,
      left: 0,
      behavior: "smooth",
    });
  };
  const handleScroll2 = () => {
    window.scrollTo({
      top: 3450,
      left: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      <Ul open={open}>
        <IMG>
          <img src="/images/logo.png" alt="logo" />
        </IMG>
        <li
          onClick={() => {
            handleScroll(intro.current);
          }}
        >
          Home
        </li>
        <li
          onClick={() => {
            handleScroll(services.current);
          }}
        >
          Services
        </li>
        <li
          onClick={() => {
            handleScroll(value.current);
          }}
        >
          Nos Valeurs
        </li>
        {window.screen.availWidth < 500 ? (
          <li
            onClick={() => {
              handleScroll(processusPhone.current);
            }}
          >
            Processus
          </li>
        ) : (
          <li
            onClick={() => {
              handleScroll2();
            }}
          >
            Processus
          </li>
        )}

        <li
          onClick={() => {
            handleScroll(contact.current);
          }}
        >
          Contact
        </li>
      </Ul>
    </>
  );
};

export default NavBar;
